export default __webpack_public_path__ + "static/B0103-8519ffe2f70c04901eae0636cab6c225.png";